import React from 'react';
import Styles from './styles.module.scss';

type Props = {
  text: string;
  variant: 'primary' | 'secondary';
  icon?: React.ReactNode;
  isActive?: boolean;
};

export const Chip: React.FC<Props> = ({ text, variant = 'primary', icon, isActive = false }) => {
  const displayText = isActive ? `#${text}` : text;
  const chipClass =
    variant === 'primary'
      ? isActive
        ? Styles.chip__primary__active
        : Styles.chip__primary
      : Styles.chip__secondary;
  const textClass =
    variant === 'primary'
      ? isActive
        ? Styles.chip__text__primary__active
        : Styles.chip__text__primary
      : Styles.chip__text__secondary;

  return (
    <div className={chipClass}>
      {icon && <span className={Styles.chip__icon}>{icon}</span>}
      <p className={textClass}>{displayText}</p>
    </div>
  );
};
